import { select, Store } from '@ngrx/store';
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
import { AppState } from '../../reducers';
import {
  selectTeamMembersInStore,
  selectTeamMembersPageLoading,
  selectTeamMembersShowInitWaitingMessage,
} from '../_selectors/team-members.selectors';

export class TeamMembersDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectTeamMembersPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(select(selectTeamMembersShowInitWaitingMessage));

    this.store.pipe(select(selectTeamMembersInStore)).subscribe((response: QueryResultsModel) => {
      this.paginatorTotalSubject.next(response.totalCount);
      this.entitySubject.next(response.items);
    });
  }
}
